import { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useFetchBranches, useFetchBrands } from 'hooks/resourceHooks';
import { client } from 'utilities/db';
import { ModalComponent } from 'components/modal';
import { CustomSelectDropdown } from 'components/select/multi';
import { TextField } from 'components/input';
import { Button } from 'components/button';
import { Toasts } from 'components/toasts';
import { useStore } from 'store';

export const ProductGroupPage = ({
  action,
  setAction,
  setAdditionType,
  refetchGroups,
  refetchCategories
}) => {
  const { brand, branch } = useStore((state) => state);

  const user = JSON.parse(localStorage.getItem('user'));
  const [level, setLevel] = useState('branch');

  // const { data: brandsData, isLoading: brandsLoading } = useFetchBrands();
  // const { data: branchesData, isLoading: branchesLoading } = useFetchBranches(
  //   brand?.id
  // );

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
    control
  } = useForm({
    defaultValues: {
      name: action === 'update' ? '' : '',
      brand: action === 'update' ? '' : '',
      branches: action === 'update' ? '' : ''
    }
  });

  useMemo(() => {
    if (action) {
      reset({
        name: action === 'update' ? '' : '',
        brand: action === 'update' ? '' : '',
        branches: action === 'update' ? '' : ''
      });
    } else {
      reset({
        name: action === 'update' ? '' : '',
        brand: action === 'update' ? '' : '',
        branches: action === 'update' ? '' : ''
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  const { mutate, isLoading, isError, error, isSuccess } = useMutation(
    (groupData) => {
      if (action === 'update') {
        return client.post(`/productGroup/findOne/${1}`, groupData);
      }
      return client.post('/productGroup/add', groupData);
    }
  );

  const handleSubmitData = (data) => {
    const { name } = data;
    if (level === 'brand') {
      mutate({
        group_name: name,
        branch_id: null,
        brand_id: parseInt(brand?.id)
      });
    } else {
      mutate({
        group_name: name,
        branch_id: branch?.id,
        brand_id: parseInt(brand?.id)
      });
    }
  };

  const closeModal = () => {
    setAction('');
    setAdditionType('');
  };

  useMemo(() => {
    if (isSuccess) {
      refetchGroups();
      refetchCategories();
      Toasts.success('Group added successfully');
      closeModal();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  useEffect(() => {
    if (!isError) return;
    Toasts.error(
      error?.response?.data?.message?.[1]?.msg || error?.response?.data?.message
    );
  }, [isError]);

  return (
    <>
      <ModalComponent
        modal={closeModal}
        handleModal={closeModal}
        modalMiddle={false}
        rightModal={true}
      >
        <h4>
          <span className="ff_semi">
            {action === 'update' ? 'Update' : 'Add New'} Product Group
          </span>
        </h4>
        <div className="mt_40"></div>
        <div className="pt_10">
          <form onSubmit={handleSubmit(handleSubmitData)}>
            <TextField
              label="Name"
              placeholder="Name"
              name="name"
              error={
                errors?.name?.type === 'required' ? 'Name is required' : ''
              }
              register={register}
              validation={{
                required: true
              }}
              required={true}
            />
            <div className="mt_16"></div>

            {/* <Controller
              name="brand"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CustomSelectDropdown
                  hookForm={true}
                  isMulti={false}
                  field={field}
                  label="Brand"
                  placeholder="Choose options"
                  options={[
                    {
                      value: brand?.id,
                      label: brand?.brand_name || '-'
                    }
                  ]}
                  error={
                    errors?.brand?.type === 'required'
                      ? 'Brand is required'
                      : ''
                  }
                  required={true}
                />
              )}
            />
            <div className="mt_30"></div>
            <Button
              label="Add Branch Level"
              color={'bg-primary'}
              onClick={() => setLevel(level === 'branch' ? 'brand' : 'branch')}
            />
            <div className="mt_16"></div>
            {level === 'branch' && (
              <Controller
                name="branches"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <CustomSelectDropdown
                    hookForm={true}
                    isMulti={true}
                    field={field}
                    label="Branch"
                    placeholder="Choose options"
                    options={[
                      {
                        value: branch?.id,
                        label:
                          branch?.branch_name || branch?.kitchen_name || '-'
                      }
                    ]}
                    error={
                      errors?.branches?.type === 'required'
                        ? 'Branch is required'
                        : ''
                    }
                    required={true}
                  />
                )}
              />
            )}
            <div className="mt_30"></div>
            <hr className="hr_modal_right" /> */}
            <div className="flex item_hend gap_16 mt_30">
              <Button
                onClick={closeModal}
                color="outline-lite"
                label={'Cancel'}
              />
              <Button
                label={action === 'update' ? 'Update' : 'Submit'}
                color="bg-primary"
                type="submit"
                disabled={isLoading}
              />
            </div>
          </form>
        </div>
      </ModalComponent>
    </>
  );
};
